/**
 * Homepage-only mobile header collection carousel.
 * Isolated from custom.js so Slick errors cannot abort Customily / engraving JS -JF
 */
(function () {
  function headerMobileColl() {
    try {
      if (!document.body.classList.contains('template-index')) return;
      if (!window.matchMedia('(max-width: 989px)').matches) return;

      var $coll = $('.header-mobile-collection .header-mob-coll');
      if (!$coll.length || $coll.hasClass('slick-initialized')) return;

      // Reuse static HTML arrows so they do not pop in after init -JF
      $coll.slick({
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        variableWidth: false,
        arrows: true,
        swipeToSlide: true,
        prevArrow: $('.header-mobile-collection .header-mob-coll-prev'),
        nextArrow: $('.header-mobile-collection .header-mob-coll-next')
      });
    } catch (err) {
      // Swallow so collection Slick never blocks other theme JS -JF
      if (window.console && console.warn) {
        console.warn('[header-mobile-coll]', err);
      }
    }
  }

  // Expose for theme editor section:load in custom.js -JF
  window.headerMobileColl = headerMobileColl;

  $(function () {
    headerMobileColl();
  });
})();
